// extracted by mini-css-extract-plugin
export default {"link":"Nav1_link__5dLkf","resume":"Nav1_resume__YQcUS","ul":"Nav1_ul__63OKn","li":"Nav1_li__9hyC1","container":"Nav1_container__ckqSy","name":"Nav1_name__wMip4","a":"Nav1_a__Bm4Y7"};